/* eslint-disable no-use-before-define */
import { useEffect } from "react";
import { makeStyles } from "tss-react/mui";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

const useStyles = makeStyles()((theme) => ({
  formControl: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    width: "100%"
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

export default function RegionSelect(props) {
  const { classes } = useStyles();

  useEffect(() => {}, [props.region]);

  return (
    <FormControl variant="outlined" className={classes.formControl}>
      <InputLabel id="region-select-label">Region</InputLabel>
      <Select
        labelId="region-select-label"
        id="region-select"
        label="Region"
        value={props.region}
        onChange={props.handleChange}
      >
        {regions.map((region) => {
          return <MenuItem value={region.id}>{region.title}</MenuItem>;
        })}
      </Select>
    </FormControl>
  );
}

const regions = [
  { id: 1, title: "North America" },
  { id: 2, title: "LATAM" },
  { id: 3, title: "Middle East" },
  { id: 4, title: "ANZ" },
  { id: 5, title: "UK" },
  { id: 6, title: "EU" },
  { id: 7, title: "Asia" },
  { id: 8, title: "Africa" }
];
